// document ready

$(document).ready(function(){
	 // Mobile footer slidetoggle
      if(window.innerWidth <= 767){
          $('.section-footer__menu-block ul').hide();
          $('.section-footer__menu-block .section-footer__title ').click(function(){
             $(this).toggleClass('active').siblings('ul').slideToggle(250); 
          });
      }
});

document.addEventListener('DOMContentLoaded', () => {

});

 
window.addEventListener('load', () => {
	setInterval( ()=> {
  	  const pblockAction = document.querySelectorAll('.template-suffix-boat-for-sale .cust-p-block.product-block .product-info');
      let initHight = 0;
      pblockAction.forEach(ele => {
        (ele.clientHeight > initHight) ? initHight = ele.clientHeight : initHight = initHight;
      })
      pblockAction.forEach(ele => {
        ele.style.height = `${initHight}px`;
      })
	},100);
});

 
window.addEventListener('resize', () => {
  if (!Shopify.designMode && window.innerWidth >= 767) { 
    if (window.RT) {
      clearTimeout(window.RT)
    }
    window.RT = setTimeout(() => {
      //this.location.reload(false);
      const pblockAction = document.querySelectorAll('.template-suffix-boat-for-sale .cust-p-block.product-block .product-info');
      let initHight = 0;
      pblockAction.forEach(ele => {
        (ele.clientHeight > initHight) ? initHight = ele.clientHeight : initHight = initHight;
      })
      pblockAction.forEach(ele => {
        ele.style.height = `${initHight}px`;
      })
    }, 200);
  }
});
